import React, { Component } from 'react';
import Locales from "../../../locales/locales";
import { Link } from "gatsby";
import t from 'prop-types';

class LocaleSwitch extends Component {
	static propTypes = {
		pagePath: t.string.isRequired,
		pageLocale: t.string.isRequired
	};

	onClick = () => {
		let localesContainer = document.querySelector('.locales-container').classList;
		if (localesContainer.contains("show")) {
			localesContainer.remove('show');
		} else {
			localesContainer.add('show');
		}
	}

	buildLocalesMarkup() {
		const { pagePath, pageLocale } = this.props;
		let nonLocalizedPath = '';
		let activeClass = '';

		let languageSwitcherMarkup = Object.keys(Locales).map((item, index) => {
			// build nonLocalized path
			if (typeof pagePath !== 'undefined' && pagePath.includes(`/${pageLocale}`)) {
				nonLocalizedPath = pagePath.split(`/${pageLocale}`)[1];
			} else {
				nonLocalizedPath = pagePath;
			}
			// handle active locale class
			if (Locales[item].path === pageLocale) {
				activeClass = 'active'
			} else {
				activeClass = '';
			}

			// build proper locale pathing
			if (Locales[item].default === true) {
				this.path = nonLocalizedPath;
			} else {
				this.path = '/' + Locales[item].path + nonLocalizedPath;
			}

			return (
				<Link
					to={this.path}
					className={activeClass}
					key={`locale-link-${index}`}
				>
					{Locales[item].path}
				</Link>
			)
		})

		let sortedLanguageSwitcherMarkup = [];

		languageSwitcherMarkup.forEach(function (e) {
			if (e.props.className.indexOf('active') >= 0) {
				sortedLanguageSwitcherMarkup.unshift(e)
			} else {
				sortedLanguageSwitcherMarkup.push(e)
			}
		});

		return (
			sortedLanguageSwitcherMarkup
		)
	}

	render() {
		return (
			<div className="locales-container" onClick={this.onClick.bind(this)}>
				<div className="locales-overlay"></div>
				{
					this.buildLocalesMarkup()
				}
			</div>
		);
	}
}

export default LocaleSwitch;
